import EpiContext from '@episerver/spa-core/Spa';
import {EsimTextEnum} from './IdfSaleEnums';

export const EsimTextFieldName = {
  Strip: "esimStripText",
  Popup: "esimPopupTexts",
  OrderSummary: "esimOrderSummaryTexts",
  Title: "esimOrderSummaryTitle",
}

export const EsimTextType = {
  NiudEsim: "niudEsim",
  NiudEsimWithModel: "niudEsimWithModel",
  NewLineEsim: "newLineEsim",
  NewLineEsimWithModel: "newLineEsimWithModel",
}



export const getTextByType = (esimTextFieldName) => {
  const esimTextsArr = EpiContext.getRoutedContent().mainContentArea.expandedValue[0].esimTexts.value;
  const store = EpiContext.getStore().getState().idfSale;
  const isEsim = store.simType === 'eSIM';
  const isNewLine = store.lineType == 3
  const isNiud = store.lineType == 1
  const selectedDevice = store.processType == 'DEVICE'
  let curEsimText;
  if (isEsim) {
    if (isNewLine) {
      if (selectedDevice) {
        curEsimText = esimTextsArr.find(t=>t.esimType === EsimTextEnum.NewLineEsimWithModel);
      } else {
        curEsimText = esimTextsArr.find(t=>t.esimType === EsimTextEnum.NewLineEsim);
      }
    }
    if (isNiud) {
      if (selectedDevice) {
          curEsimText = esimTextsArr.find(t=>t.esimType === EsimTextEnum.NiudEsimWithModel);
      }
      else {
          curEsimText = esimTextsArr.find(t=>t.esimType === EsimTextEnum.NiudEsim);
      }
    }
     return curEsimText[esimTextFieldName];
  }
  return;
}
